module.exports = __webpack_public_path__ + "static/media/CNY_Header.fd538c0c.png";